module.exports = __webpack_public_path__ + "static/media/point6.42d3938e.png";